import { MutableState } from '../State';

/**
 * Initialize pet starter pack promo start time
 * @param state
 * @param now
 * @returns
 */
export function initPetStarterPackPromo(
  state: MutableState,
  now: number,
): void {
  if (!state.match2.shopBundles) state.match2.shopBundles = {};
  if (state.match2.shopBundles.petStarterPackStartedAt) return;
  state.match2.shopBundles.petStarterPackStartedAt = now;
}
